import { GroupMarketingPreferenceFormValue } from './group-marketing-preference-form-value.type';

export interface GroupMarketingPreferenceFormConfig {
  initialValue?: Partial<GroupMarketingPreferenceFormValue>;
}
